/* Runde 335: die 31 Original-Icons des Pakets Booksmith_Marketing (03_Assets/icons/sprite.svg) — 24 × 24, currentColor, Strichstärke 1,7. Dekorativ (aria-hidden), Buttons tragen ihren Text. */
const BM: Record<string, string> = {
  "book": "<path d=\"M3 4h6l3 2 3-2h6v15h-6l-3 2-3-2H3zM12 6v15\"/>",
  "overview": "<path d=\"M3 12h4v8H3zM10 4h4v16h-4zM17 8h4v12h-4z\"/>",
  "target": "<circle cx=\"12\" cy=\"12\" r=\"8\"/><circle cx=\"12\" cy=\"12\" r=\"4\"/><path d=\"m12 12 8-8M16 4h4v4\"/>",
  "search": "<circle cx=\"10\" cy=\"10\" r=\"6\"/><path d=\"m15 15 6 6\"/>",
  "calendar": "<rect x=\"4\" y=\"5\" width=\"16\" height=\"16\" rx=\"1\"/><path d=\"M8 2v6M16 2v6M4 10h16\"/>",
  "chevron-left": "<path d=\"m15 5-7 7 7 7\"/>",
  "chevron-right": "<path d=\"m9 5 7 7-7 7\"/>",
  "chevron-down": "<path d=\"m5 9 7 7 7-7\"/>",
  "columns": "<rect x=\"3\" y=\"4\" width=\"18\" height=\"16\" rx=\"1\"/><path d=\"M9 4v16M15 4v16\"/>",
  "filter": "<path d=\"M3 5h18l-7 8v6l-4 2v-8z\"/>",
  "plus": "<path d=\"M12 4v16M4 12h16\"/>",
  "play": "<path d=\"m8 4 12 8-12 8z\"/>",
  "pause": "<path d=\"M8 4v16M16 4v16\"/>",
  "check": "<path d=\"m4 12 5 5L20 6\"/>",
  "close": "<path d=\"m5 5 14 14M19 5 5 19\"/>",
  "copy": "<rect x=\"8\" y=\"8\" width=\"12\" height=\"13\" rx=\"1\"/><path d=\"M16 8V3H3v13h5\"/>",
  "upload": "<path d=\"M12 16V3m-5 5 5-5 5 5M4 15v6h16v-6\"/>",
  "download": "<path d=\"M12 3v13m-5-5 5 5 5-5M4 17v4h16v-4\"/>",
  "edit": "<path d=\"m4 16 12-12 4 4L8 20H4zM14 6l4 4\"/>",
  "info": "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M12 10v7M12 6.5v.1\"/>",
  "lock": "<rect x=\"5\" y=\"10\" width=\"14\" height=\"11\" rx=\"1\"/><path d=\"M8 10V6a4 4 0 0 1 8 0v4M12 14v3\"/>",
  "spark": "<path d=\"m12 2 2.5 7.5L22 12l-7.5 2.5L12 22l-2.5-7.5L2 12l7.5-2.5z\"/>",
  "file": "<path d=\"M5 3h9l5 5v13H5zM14 3v6h5M8 13h8M8 17h6\"/>",
  "chart": "<path d=\"M3 3v18h18M6 16l5-6 4 3 5-8\"/>",
  "history": "<path d=\"M3 11a9 9 0 1 1 3 7M3 4v7h7M12 7v6l4 2\"/>",
  "flag": "<path d=\"M5 22V3m0 1h13l-3 4 3 4H5\"/>",
  "settings": "<path d=\"M4 6h16M4 12h16M4 18h16\"/><circle cx=\"8\" cy=\"6\" r=\"2\" fill=\"var(--bm-surface,#fff)\"/><circle cx=\"16\" cy=\"12\" r=\"2\" fill=\"var(--bm-surface,#fff)\"/><circle cx=\"10\" cy=\"18\" r=\"2\" fill=\"var(--bm-surface,#fff)\"/>",
  "moon": "<path d=\"M20 15A9 9 0 0 1 9 4a9 9 0 1 0 11 11z\"/>",
  "arrow-right": "<path d=\"M4 12h16m-6-6 6 6-6 6\"/>",
  "external": "<path d=\"M14 3h7v7m0-7L10 14M10 4H3v17h17v-7\"/>",
  "warning": "<path d=\"m12 3 10 18H2zM12 9v5M12 17v.5\"/>",
};
export const BM_ICONS = Object.keys(BM);
export const bi = (name: string, cls = ''): string => { const body = BM[name]; if (!body) return ''; return `<svg class="icon${cls ? ` ${cls}` : ''}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${body}</svg>`; };
